export default __webpack_public_path__ + "static/media/workdayAssistant.2b2b83bf.svg";